import { render, staticRenderFns } from "./RaceHeads.vue?vue&type=template&id=07e9afa5&"
import script from "./RaceHeads.vue?vue&type=script&lang=js&"
export * from "./RaceHeads.vue?vue&type=script&lang=js&"
import style0 from "./RaceHeads.vue?vue&type=style&index=0&id=07e9afa5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports